import React, { useEffect, useState } from "react";
import { Form, Button, Col, InputGroup, FormControl } from "react-bootstrap";
import { withCookies } from "react-cookie";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import moment from "moment";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import htmlToDraft from "html-to-draftjs";
import { EditorState, ContentState } from "draft-js";
import { useTranslation } from "react-i18next";
import configVars from "../../config";

const ActionPlan = ({ selectedTask, board, config }) => {
  const [translation] = useTranslation("translations");
  const allTaskTypes = config && config["task_type"];
  const allTaskStatus = config && config["task_status"];
  const [users, setUsers] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [title, setTitle] = useState({
    value: "",
    error: false,
  });
  const [factors, setFactors] = useState("");
  const [action, setAction] = useState("");
  const [taskType, setTaskType] = useState(
    allTaskTypes ? Object.keys(allTaskTypes)[0] : null
  );
  const [status, setStatus] = useState("");
  const timeline = {
    startDate: selectedTask?.action_plan_timeline_start
      ? moment(new Date(selectedTask?.action_plan_timeline_start)).format(
          "MM/DD/YYYY"
        )
      : moment(new Date()).format("MM/DD/YYYY"),
    endDate: selectedTask?.action_plan_timeline_end
      ? moment(new Date(selectedTask?.action_plan_timeline_end)).format(
          "MM/DD/YYYY"
        )
      : moment(new Date()).format("MM/DD/YYYY"),
  };

  useEffect(() => {
    if (selectedTask) {
      setTitle({ value: selectedTask.title, error: false });

      let _factorDesc = null;
      if (selectedTask?.idea_bank_factor_description) {
        _factorDesc = selectedTask?.idea_bank_factor_description;
      } else if (selectedTask?.current_situation_factor_description) {
        _factorDesc = selectedTask?.current_situation_factor_description;
      } else if (selectedTask?.action_plan_factor_description) {
        _factorDesc = selectedTask?.action_plan_factor_description;
      }

      if (_factorDesc) {
        const contentBlock1 = htmlToDraft(_factorDesc);

        if (contentBlock1) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock1.contentBlocks
          );
          const editorState = EditorState.createWithContent(contentState);
          setFactors(editorState);
        }
      }

      let _decidedAction = null;
      if (selectedTask?.action_plan_decided_action) {
        _decidedAction = selectedTask?.action_plan_decided_action;
      } else if (selectedTask?.idea_for_change_description) {
        _decidedAction = selectedTask?.idea_for_change_description;
      } else if (selectedTask?.implementation_decided_action) {
        _decidedAction = selectedTask?.implementation_decided_action;
      } else if (selectedTask?.evaluation_result) {
        _decidedAction = selectedTask?.evaluation_result;
      }

      if (_decidedAction) {
        const contentBlock2 = htmlToDraft(_decidedAction);
        if (contentBlock2) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock2.contentBlocks
          );
          const editorState = EditorState.createWithContent(contentState);

          setAction(editorState);
        }
      }

      if (selectedTask?.responsible_persons) {
        setUsers(selectedTask?.responsible_persons);
      }
      setStatus(selectedTask?.task_status?.term_id);
      setTaskType(selectedTask?.task_type?.term_id);
    }
  }, [selectedTask]);
  useEffect(() => {
    if (board) {
      setAllUsers(board?.associated_users);
    }
  }, [board]);

  return (
    <Form>
      <div className="">
        <Col className="">
          <div className="d-lg-flex flex-lg-column">
            <Form.Group className="mb-3">
              <Form.Label>
                <b>{translation("task_forms.action_plan.field1.label")}</b>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder={translation(
                  "task_forms.action_plan.field1.placeholder"
                )}
                value={title?.value}
                disabled
                isInvalid={title?.error}
                style={{ fontSize: "14px", padding: "0.5rem 0.5rem" }}
              />
              {title?.error && (
                <Form.Control.Feedback type="invalid">
                  {translation("task_forms.action_plan.field1.error")}
                </Form.Control.Feedback>
              )}
            </Form.Group>
            <Form.Group style={{ width: "100%" }}>
              <Form.Label>
                <b>{translation("task_forms.action_plan.field2.label")}</b>
              </Form.Label>
              <Typeahead
                id="basic-typeahead-multiple"
                labelKey="display_name"
                multiple
                disabled
                options={allUsers}
                onChange={(e) => {}}
                selected={users}
              />
            </Form.Group>
          </div>
        </Col>
        <Col className="">
          <div className="d-flex justify-content-center">
            {config &&
              allTaskTypes &&
              Object.keys(allTaskTypes)?.map((item, index) => {
                return (
                  <Col className="d-flex pe-2" key={index}>
                    <Button
                      variant={
                        parseInt(taskType) === parseInt(item)
                          ? "action-blue"
                          : "outline-action-blue"
                      }
                      className={`${
                        parseInt(taskType) === parseInt(item)
                          ? `text-white`
                          : `text-sy-black`
                      } rounded`}
                      style={{
                        width: "100%",
                        textTransform: "uppercase",
                        fontWeight: "bold",
                      }}
                      disabled
                    >
                      {allTaskTypes[item]?.name}
                    </Button>
                  </Col>
                );
              })}
          </div>

          <div className="d-flex justify-content-center mt-3">
            <InputGroup className="mb-2">
              <Form.Label style={{ width: "100%" }}>
                <b>{translation("task_forms.action_plan.field3.label")}</b>
              </Form.Label>

              <InputGroup.Text>
                <i className="fa fa-calendar" aria-hidden="true"></i>
              </InputGroup.Text>
              <DateRangePicker disabled initialSettings={timeline}>
                <FormControl type="text" />
              </DateRangePicker>
            </InputGroup>
          </div>
        </Col>
      </div>

      <div className="d-flex mt-3">
        <Form.Label>
          <b>{translation("task_forms.action_plan.field4.label")}</b>
        </Form.Label>
      </div>
      <div className="d-flex">
        {config &&
          allTaskStatus &&
          Object.keys(allTaskStatus)?.map((item, index) => {
            return (
              <button
                key={index}
                style={{
                  height: "32px",
                  width: "90px",
                  padding: "0px 0px",
                  fontSize: "13px",
                  borderRadius: "32px",
                  marginRight: "10px",
                }}
                type="button"
                className={` btn border-1 ${
                  status === allTaskStatus[item].term_id
                    ? `btn-sy-${allTaskStatus[item].slug} text-white`
                    : `btn-outline-sy-${allTaskStatus[item]?.slug}`
                }`}
                disabled
              >
                {allTaskStatus[item]?.name}
              </button>
            );
          })}
      </div>

      <Form.Group className="mb-3 mt-3">
        <Form.Label>
          <b>{translation("task_forms.action_plan.field5.label")}</b>
        </Form.Label>

        <Editor
          toolbar={configVars?.wysiwygToolbarOptions}
          editorState={factors}
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          editorClassName="editor-wrapper"
          disabled
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>
          <b>{translation("task_forms.action_plan.field6.label")}</b>
        </Form.Label>

        <Editor
          toolbar={configVars?.wysiwygToolbarOptions}
          editorState={action}
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          editorClassName="editor-wrapper"
          disabled
        />
      </Form.Group>
    </Form>
  );
};

export default withCookies(ActionPlan);
